import React, { useState, useEffect, useRef, useCallback   } from 'react';
import { Form,Input,Card, Col, Row, Typography,Button,Tooltip, Popconfirm,
  message, Modal, Radio, Checkbox, DatePicker,AutoComplete,
  Descriptions} from "antd";
import dayjs from "dayjs";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import PageLoader from "../../components/custom/PageLoader";
import { useNavigate, useLocation } from "react-router-dom";
import CkCustomUploadAdapter from "../../utils/CkCustomUploadAdapter";
import {
  ArrowLeftOutlined,
    DeleteOutlined,
    EditOutlined,
//   UserOutlined,
} from "@ant-design/icons";
import moment, { duration, Moment } from "moment";
import { Color } from 'antd/es/color-picker';
import stylesCheckbox from "./Notification.module.css";
import { useForm } from "antd/es/form/Form";
import { getAddressSearchResults} from '../../services/mapBoxServiceIntegration';
import { AddressSearchResponse, MapboxFeature, MarkerPoint } from '../../services/mapBoxSearchType';
import geofenceNotificationApi, {GeoFencePostBody, GeofenceNotificationImageParams,
    GeofenceNotificationDetailsParams, GeofenceAnnouncementImageResponse,
    GeofenceNotificationUpdateParams,
    GeofenceNotificationDescriptionPatchBody } from '../../services/geofenceNotificationApi';
import debounce from 'lodash/debounce';
import Spinner from '../../components/custom/Spinner';
import GeofenceMobilePreviewPage from './GeofenceMobilePreview'
import { NotificationStatusMapper } from "../../utils/notificationStatusMapper";
import TimeZone from "../../services/timeZone";
import { FIFTY_MB_FILE_SIZE_VALUE } from "../../constants/appConstants";

const { Title, Text } = Typography;

interface Props {
  form: any;
  styles: any;
}

const CreateGeofencePage: React.FC = () => {

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
    const [isNavigationAdded, setIsNavigationAdded] = useState<boolean>(false);
    const [publishModal, setPublishModal] = useState<{ open: boolean }>({ open: false });
    const [draftModal, setDraftModal] = useState<{ open: boolean }>({ open: false });
    const [geofenceDescription, setGeofenceDescription] = useState<string>("");
    const [formAction, setFormAction] = useState<'draft' | 'publish' | null>(null);

    const [imageData, setImageData] = useState<{ 
      file: File; 
      base64Data: string 
    } []> ([]);
   
    // const [features, setFeatures] = useState<MapboxFeature[]>([]);
   
  const [inputValue, setInputValue] = useState<string>('');
  const [options, setOptions] = useState<{ value: string; label: string; feature: any }[]>([]);
  const [selectedFeature, setSelectedFeature] = useState<any>(null);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  //const [existingImageIds, setExistingImageIds] = useState<string[]>([]);
  const [imagesInServerUrlArr, setImagesInServerUrlArr] = useState<string[]>([]);
  const [centreCoordinate, setCentreCoordinate] = useState<string[]>([]);
  
  const [existingImages, setExistingImages] = useState<{ id: string; fileUrl: string; fileSize: number }[]>([]);

  const latestSearchRef = useRef('');
  const debounceSearchRef = useRef<(value: string) => void>();
  //const [markerPoint, setMarkerPoint] = useState<MarkerPoint | null>(null);
  
  //const debounceSearch = useCallback(debounce(handleSearch, 300), []);
  //const debounceSearch = useMemo(() => debounce(handleSearch, 300), []);
    const editorRef = useRef<any>(null);
    
    const location = useLocation();
    const { geofenceNotificationId, operationName, redirectedFrom } = location.state || {};

    const searchParams = new URLSearchParams(location.search);
    const identifier = searchParams.get('identifier');
    const navigationTitle = searchParams.get('navigationTitle');
    const [displayMobilePreview, setdisplayMobilePreview] = useState<boolean>(false);
    const [hasResults, setHasResults] = useState(true);
    const [isAddressSelected, setIsAddressSelected] = useState(false);
    const [totalImageFileSize, setTotalImageFileSize] = useState(0); // in bytes
    const imageMapRef = useRef<Map<string, number>>(new Map());
    const [editorInstance, setEditorInstance] = useState<any>(null);

    let baseMode : string = '';
    if(identifier === "999" && navigationTitle?.toLowerCase() === "create"){
      baseMode = "create";
    }

    if(operationName && geofenceNotificationId){
      baseMode = operationName;
    }
    
    const navigate = useNavigate();

    const isGeGeofenceNotificationtDetails= baseMode?.toLowerCase() === "update" || 
        baseMode?.toLowerCase() === "view";
        
    const [mode, setMode] = useState(baseMode);

    const handleSearch = async (value: string) => {
      latestSearchRef.current = value;
        //setInputValue(value); // update input immediately
        if (!value) {
          setOptions([]);
          setHasResults(true);
          return;
        }

        try {
          const result: AddressSearchResponse = await getAddressSearchResults(value);

          if (latestSearchRef.current === value) {

            if (result.features.length === 0) {
              // No result case
              setHasResults(false);
              setOptions([
                {
                  value: "no-search-found",
                  label: <span style={{ color: "#999" }}>No search found</span>,
                  disabled: true,
                },
              ]);
            }
            else {
              const opts = result.features.map((f) => ({
                value: f.properties.mapbox_id,
                key: f.properties.mapbox_id,
                // label: f.properties.name,
                label: (
                  <div>
                    <div style={{ fontWeight: 450 }}>{f.properties.name}</div>
                    <div style={{ color: "#888", fontSize: 12 }}>{f.properties.place_formatted}</div>
                  </div>
                ),
                feature: f,
              }));

              setOptions(opts);
         }
        }
        } catch (err) {
          console.error("Search failed:", err);
          setHasResults(false);
          setOptions([]);
        }
    };
  
  useEffect(() => {
    if (!editorInstance) return;
    try {
      if (mode === "view") {
        editorInstance.enableReadOnlyMode("viewMode");
      } else {
        editorInstance.disableReadOnlyMode("viewMode");
      }
    } catch (err) {
      // ignore if editor lifecycle not ready
      console.debug("CKEditor readOnly toggle failed:", err);
    }
  }, [mode, editorInstance]);

  //Log it for monitoring purpose
  useEffect(() => {
    console.log("Total image size:", (totalImageFileSize / (1024 * 1024)).toFixed(2), "MB");
  }, [totalImageFileSize]);

  const handleEditorChange = useCallback((_: unknown, editor: ClassicEditor) => {
    const data = editor.getData();
    setGeofenceDescription(data);
  }, []);

 const handleReady = (editor: any) => {
   // Attach custom upload adapter
  editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) =>
    new CkCustomUploadAdapter(
      loader,
      handleBeforeUpload,
      imageMapRef,
      setTotalImageFileSize,
      setImageData
    );

    //initial read-only state
    if (mode === "view") {
      try {
        editor.enableReadOnlyMode("viewMode");
       } 
       catch {
        } 
    }

  // Listen for content changes
  editor.model.document.on("change:data", () => {
    const data = editor.getData();
    setGeofenceDescription(data);

    const currentImageSrcs = extractImageUrls(data);

    // Recalculate total file size
    let recalculatedSize = 0;
    const newMap = new Map<string, number>();

    currentImageSrcs.forEach((src) => {
      const size = imageMapRef.current.get(src);
      if (size) {
        recalculatedSize += size;
        newMap.set(src, size);
      }
    });

    imageMapRef.current = newMap;
    setTotalImageFileSize(recalculatedSize);

    // Clean up imageData to only include existing images
    setImageData((prev) => prev.filter((img) => currentImageSrcs.includes(img.src)));
  });
};

  //TO DO: REVIEW AND REMOVE THIS
  const extractImageUrlsByDesc = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const images = Array.from(div.getElementsByTagName("img"));
    return images.map((img) => img.getAttribute("src") || "");
  };

//To do: check this function
const handleBeforeUpload = (file: File) => {
    const newSize = totalImageFileSize + file.size;
    if (newSize > FIFTY_MB_FILE_SIZE_VALUE) {
      alert(`Total image upload limit exceeded Max 50 MB)!`);
      return false;
    }
    return true;
  };

  const handleSelect = (value: string, option: any) => {
  const feature = option?.feature || option; // fallback if option itself is the feature

  if (!feature) return;

  const displayText = feature.properties?.place_formatted || feature.properties?.full_address;
  setInputValue(displayText);

  setSelectedFeature(feature);
  //Clearing centre coordinate state if user reselect from the address.
  setCentreCoordinate([]);
};

const buildMarkerPoint = (feature: any) => {
    return {
      type: feature.type,
      geometry: {
        type: feature.geometry.type,
        coordinates: [
        feature.properties.coordinates.longitude, 
        feature.properties.coordinates.latitude
      ],
        //coordinates: feature.geometry.coordinates,
      },
      properties: {
        id: feature.properties.mapbox_id,
        name: feature.properties.name,
      },
    };
  };

  useEffect(() => {
    setMode(baseMode);

    const fetchData = async () => {
      if (isGeGeofenceNotificationtDetails) {
        try {
          await getGeofenceNotificationDetails();
        } catch (error) {
          console.error("Failed to fetch Geofence notification details:", error);
        } finally {
          setIsPageLoading(false);
        }
      } else {
        setIsPageLoading(false);
      }
    };

    fetchData();
  }, [baseMode]);

    const handleAddNavigation = async () => {
        setIsNavigationAdded(true);
    };

    const handleEdit = async () => {
      messageApi.success("Now you can edit the notification");
      setMode("update");
    };

// Setup debounced search once
      useEffect(() => {
        debounceSearchRef.current = debounce(handleSearch, 300);
      }, []);

      // Optional: cleanup debounce on unmount
      useEffect(() => {
        return () => {
          debounceSearchRef.current?.cancel();
        };
      }, []);

  const getGeofenceNotificationDetails = async () => {
    try {
      const geofenceItems : GeofenceNotificationDetailsParams = await geofenceNotificationApi.getGeofenceNotificationById(geofenceNotificationId);
      if (geofenceItems) {

                form.setFieldsValue({
                    CampaignName: geofenceItems.campaignName,
                    startDateTime: geofenceItems.startDate && geofenceItems.startTime
                      ?  dayjs(`${geofenceItems.startDate} ${geofenceItems.startTime}`, "YYYY-MM-DD hh:mm A")
                      : null,

                    endDateTime: geofenceItems.endDate && geofenceItems.endTime
                            ? dayjs(`${geofenceItems.endDate} ${geofenceItems.endTime}`, "YYYY-MM-DD hh:mm A")
                            : null,
                    notifications: [
                          ...(geofenceItems.inAppNotification ? ["inapp"] : []),
                          ...(geofenceItems.pushNotification ? ["push"] : []),
                          ...(geofenceItems.emailNotification ? ["email"] : []),
                        ],
                    Title : geofenceItems.title,
                    Subtitle : geofenceItems.subTitle,
                    Subject: geofenceItems.subjectLine,
                    EmailText: geofenceItems.emailText,
                    Address: geofenceItems.locationAddress?.trim() || '',
                    Latitude: geofenceItems.locationAddress?.trim() ? "" :
                       geofenceItems.centreCoordinate?.[1],
                    Longitude: geofenceItems.locationAddress?.trim() ? "" : 
                        geofenceItems.centreCoordinate?.[0],
                    
                    RadialDistance: geofenceItems.km && geofenceItems.km !== 0 
                      ? geofenceItems.km 
                      : geofenceItems.mile && geofenceItems.mile !== 0 
                        ? geofenceItems.mile 
                        : null,
                    DistanceUnit: geofenceItems.km && geofenceItems.km !== 0 ? "km" : "miles",
                });

                if (!geofenceItems.locationAddress?.trim()) {
                  setIsAddressSelected(false);
                } else {
                  setIsAddressSelected(true);
                }

                setInputValue((geofenceItems.locationAddress?.trim() || ''));

                if (Array.isArray(geofenceItems.centreCoordinate)) {
                  setCentreCoordinate(geofenceItems.centreCoordinate.map(String));
                }
                
                let contentWithImage = geofenceItems.description || "";
                // let contentWithImage = geofenceItems.description?.replace(
                //     /data:image\/[^;]+;base64,[^"]+/g,
                //     (match, i) => {
                //       const imageUrl = geofenceItems.geofenceAnnouncementImageResponses?.[i]?.fileUrl;
                //       return imageUrl || match;
                //     }
                //   ) || "";
                
                if (
                  Array.isArray(geofenceItems.geofenceAnnouncementImageResponses) &&
                  geofenceItems.geofenceAnnouncementImageResponses.length > 0 &&
                      !contentWithImage.includes("<img")
                 ) 
                  {
                  const imagesHtml = geofenceItems.geofenceAnnouncementImageResponses
                    .map(
                      (img: any) =>
                        `<p><img src="${img.fileUrl}" alt="${img.fileName}" style="width: 120px;" /></p>`
                    )
                    .join("");

                  contentWithImage = imagesHtml + contentWithImage;
                }
                setGeofenceDescription(contentWithImage);

                if (
                  Array.isArray(geofenceItems.geofenceAnnouncementImageResponses) &&
                  geofenceItems.geofenceAnnouncementImageResponses.length > 0)
                  {
                    //to check if this code really required or not
                    // const ids = geofenceItems.geofenceAnnouncementImageResponses.map(img => img.id);
                    // setExistingImageIds(ids);

                    const imageData = geofenceItems.geofenceAnnouncementImageResponses.map((img: any) => ({
                      id: img.id,
                      fileUrl: img.fileUrl,
                      fileSize: img.fileSize
                    }));

                    setExistingImages(imageData);

                    const fileUrl = geofenceItems.geofenceAnnouncementImageResponses.map(serverFileUrl => serverFileUrl.fileUrl);
                    setImagesInServerUrlArr(fileUrl);
                  }
                  
                  setIsNavigationAdded(geofenceItems.isNavigation);
                  /*
                  if(geofenceItems.markerPoint){
                    const parsed: MarkerPoint = JSON.parse(geofenceItems.markerPoint);
                    setMarkerPoint(parsed);
                  }
                  */
            }
      } 
      catch (error) {
      console.error("Error loading items:", error);
    }
  };

    const handleRemoveNavigation = async () => {
        setIsNavigationAdded(false);
    };

  const validationForSaveAsDraft = async () => {
    try {
      await form.validateFields(["CampaignName"]);
      return true;
    } catch (validationError) {
      messageApi.error('Please fill in all mandatory fields before saving as draft.');
      return false;
    }
  };

  const handleSaveAsDraft = async () => {
      const statusId = Number(NotificationStatusMapper.getNotificationStatusId('Draft'));
      try {
       
      const isValid = await validationForSaveAsDraft();
        if(!isValid){
          return;
        }

        let response : any;
        if (mode === "create") {
          response = await handleGeofencePost(statusId);
        }
        else if (mode === "update") {
          response = await handleGeofenceUpdate(statusId);
        }

        if (response !== -999) {
          setTimeout(() => {
            navigate(-1);
          }, 1200);
        }

      } catch (err) {
        messageApi.error("Something went wrong");
        console.error("Failed to save as draft geofence notification:", err);
      }
    };
    
    const handleMobilePreview = async () => {
      setdisplayMobilePreview(true);
    };
    
    const handlePublish = async () => {
      try {
        const statusId = Number(NotificationStatusMapper.getNotificationStatusId('Active'));
        let response : any;
        if(mode === "create"){
          response = await handleGeofencePost(statusId);
        }
        else if(mode === "update"){
          response = await handleGeofenceUpdate(statusId);
        }
        
        if (response !== -999) {
          setTimeout(() => {
            navigate(-1);
          }, 1200);
        }
      }
      catch (err) {
        messageApi.error("Something went wrong");
        console.error("Failed to publish geofence notification:", err);
      }
    };

    const selectedNotifications = Form.useWatch("notifications", form);
    const isEmailSelected = selectedNotifications?.includes("email");

    //save as draft 0 or publish 1
     const handleGeofencePost = async (statusId: number ) => {
        //TO : OBSERVE THIS
        //const editorData = editorRef.current?.getData() || "";
       
       if (Number(totalImageFileSize) > FIFTY_MB_FILE_SIZE_VALUE) {
         messageApi.error("Total image size cannot exceed 50MB.");
         setPublishModal({ open: false });
         return -999;
       }
      
        const editorData = geofenceDescription;
        const editorImages = editorData.match(/<img\s+[^>]*src=["'][^"']+["']/gi) || [];
        const base64ImgTags = editorData.match(/<img[^>]+src=["']data:image\/[^"']+["'][^>]*>/g) || [];
        const totalImages = editorImages.length;

        if (totalImages > 20) {
            messageApi.error('Maximum 20 image are allowed.');
            setPublishModal({ open: false });
            return -999;
        }

        try {
          setPublishModal({ open: false });

          let successMessage : string = '';
          if(statusId === NotificationStatusMapper.getNotificationStatusId('Draft') ){
            setIsDraftSaving(true);
            successMessage= "Notification saved successfully as Draft.";
          }

          if(statusId === NotificationStatusMapper.getNotificationStatusId('Active')){
            setIsPublishing(true);
            successMessage = "Notification scheduled successfully.";
          }
          const distanceUnit = form.getFieldValue("DistanceUnit");
          const radialDistance = form.getFieldValue("RadialDistance");
          const selected = form.getFieldValue("notifications") || [];

          const start = form.getFieldValue("startDateTime");
          const end = form.getFieldValue("endDateTime");
          const valuesAddressInfo = form.getFieldsValue([ "Latitude", "Longitude"]);
          
          const isLatLongEmpty =
            !valuesAddressInfo.Latitude && !valuesAddressInfo.Longitude;

          let markerPointObj: any = null;
          if (isLatLongEmpty && selectedFeature) {
             markerPointObj =buildMarkerPoint(selectedFeature);
             //markerPointStr = JSON.stringify(markerPointObj);
          }
            const bodyGeofence: GeoFencePostBody = {
                  campaignName: form.getFieldValue("CampaignName"),
                  status: statusId,
                  ...(start
                    ? {
                        startDate: dayjs(start).format("YYYY-MM-DD"),
                        startTime: dayjs(start).format("hh:mm A"),
                      }
                    : {}),
                ...(end
                  ? {
                      endDate: dayjs(end).format("YYYY-MM-DD"),
                      endTime: dayjs(end).format("hh:mm A"),
                    }
                  : {}),
                  ...(valuesAddressInfo.Latitude && valuesAddressInfo.Longitude
                      ? {
                          centreCoordinate: [
                            String(valuesAddressInfo.Longitude),
                            String(valuesAddressInfo.Latitude),
                          ],
                        }
                      : markerPointObj?.geometry?.coordinates?.[0] != null &&
                        markerPointObj?.geometry?.coordinates?.[1] != null
                      ? {
                          centreCoordinate: [
                            markerPointObj.geometry.coordinates[0].toString(),
                            markerPointObj.geometry.coordinates[1].toString(),
                          ],
                        }
                      : {}),

                     ...(isNavigationAdded ? { isNavigation: isNavigationAdded } : {}),
                     ...(inputValue ? { locationAddress: inputValue } : {}),

                      ...(selected.includes("inapp") ? { inAppNotification: true } : {}),
                      ...(selected.includes("push") ? { pushNotification: true } : {}),
                      ...(selected.includes("email") ? { emailNotification: true } : {}),

                      ...(form.getFieldValue("Subject")
                        ? { subjectLine: form.getFieldValue("Subject") }
                        : {}),

                      ...(form.getFieldValue("EmailText")
                        ? { emailText: form.getFieldValue("EmailText") }
                        : {}),

                    ...(distanceUnit === "km" && radialDistance
                      ? { km: radialDistance }
                      : {}),

                    ...(distanceUnit === "miles" && radialDistance
                      ? { mile: radialDistance }
                      : {}),

                    ...(form.getFieldValue("Title")
                      ? { title: form.getFieldValue("Title") }
                      : {}),

                    ...(form.getFieldValue("Subtitle")
                      ? { subTitle: form.getFieldValue("Subtitle") }
                      : {}),

                    ...(geofenceDescription ? { description: geofenceDescription } : {}),

                  timeZone: TimeZone.getFriendlyTimeZone()
                  };

            const startTimeLog = performance.now(); 
            console.log("Starting post geofence call at", new Date().toISOString()); 
            
            console.log("post body", bodyGeofence);
            const resultPostGeoNotification = await geofenceNotificationApi.postGeofenceNotification(bodyGeofence);            
            
            const endTimeLog = performance.now(); 
             console.log("API call ended post geofence", new Date().toISOString(), 
             "| Duration:", (endTimeLog - startTimeLog).toFixed(2), "ms");

            const uploadedUrls = await uploadGeofenceNotificationImagesInServer(resultPostGeoNotification.id);
            
            const endTimeTotalImagesUpload = performance.now(); 
             console.log("End of Image upload total time taken : ", new Date().toISOString(), 
             "| Duration:", (endTimeTotalImagesUpload - startTimeLog).toFixed(2), "ms");

            /*Image Upload in the server
            const uploadedGeofenceNotificationImageUrls: string[] = [];
            for (const img of imageData) {
               const params: GeofenceNotificationImageParams = {
                GeofenceAnnouncementSupportID: resultPostGeoNotification.id,
                GeofenceAnnouncementFile: img.file
              };

              const responsePostUpload = await geofenceNotificationApi.postGeofenceNotificationImageUpload(params);
              if (responsePostUpload?.fileUrl) {
                uploadedGeofenceNotificationImageUrls.push(responsePostUpload.fileUrl);
              }
            }
            */
            if(uploadedUrls && uploadedUrls.length > 0){
              patchDescriptionFromBase64ToImageUrl(uploadedUrls, resultPostGeoNotification.id, geofenceDescription);
            }
            /*
            let geofenceDescriptionWithoutBase64 : string = '';
            if(uploadedGeofenceNotificationImageUrls.length > 0 && base64ImgTags.length > 0){

                let index = 0;
                const base64ImgRegex = /<img[^>]+src=["']data:image\/(?:png|jpeg|jpg|gif|webp);base64,[\s\S]+?["'][^>]*>/g;

                geofenceDescriptionWithoutBase64 = geofenceDescription.replace(base64ImgRegex, (match) => {
                  const fileUrl = uploadedGeofenceNotificationImageUrls[index++];
                  if (fileUrl) {
                    return `<img src="${fileUrl}" alt="uploaded-image-${index}" style="width: 120px;" />`;
                  }
                  return match;
                });

                  const descriptionPatchBody : GeofenceNotificationDescriptionPatchBody = {
                    id: resultPostGeoNotification.id,
                    description : geofenceDescriptionWithoutBase64,
                  };

                  geofenceNotificationApi.patchGeofenceNotificationDescription(descriptionPatchBody);
                  console.log("PUT BODY", JSON.stringify(descriptionPatchBody, null, 2));
            }
            */
            messageApi.success(successMessage);

            const endTimeTotalTimeTaken = performance.now(); 
             console.log("geo fence post API total time taken", new Date().toISOString(), 
             "| Duration:", (endTimeTotalTimeTaken - startTimeLog).toFixed(2), "ms");
        } catch (err) {
          
            const apiErrorMessage = err?.response?.data?.Message;
            messageApi.error(apiErrorMessage || 'Something went wrong');
            console.log("Failed to geofence post notification:", err);
            return -999;
        }
        finally{
            setIsDraftSaving(false);
            setIsPublishing(false);
        }
    };

    // Extract all image URLs from CKEditor HTML
    const extractImageUrls = (html: string): string[] => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      return Array.from(doc.querySelectorAll("img"))
        .map((img) => img.getAttribute("src") || "")
        .filter(Boolean);
    };

    // Clean up empty <figure> or <img> tags if any
    const cleanEmptyFigures = (html: string): string => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      doc.querySelectorAll("figure").forEach((fig) => {
        const img = fig.querySelector("img");
        if (!img || !img.getAttribute("src")) fig.remove();
      });
      return doc.body.innerHTML;
    };

    const calculateTotalFileSizeAttachedInEditor = (imageUrls: string[]) => {
      try {
        const existingFileSizeArr = existingImages.filter((img) => imageUrls.includes(img.fileUrl))
          .map((img) => img.fileSize);

        const existingTotalFileSize = existingFileSizeArr.reduce((sum, size) => sum + size, 0);
        const finalTotalFileSize = existingTotalFileSize + (Number(totalImageFileSize) || 0);
        return finalTotalFileSize;
      } catch (err) {
        messageApi.error("Something went wrong");
        console.error("Failed in calculation of total file size:", err);
        return 0;
      }
    };

    const handleGeofenceUpdate = async (statusId: number ) => {
      
        // Step 1: Clean the HTML
        const cleanedDescription = cleanEmptyFigures(geofenceDescription);
        // Step 2: Extract all image URLs currently in the editor
        const currentImageUrls = extractImageUrls(cleanedDescription);
        // Step 3: Compare with server URLs and filter the kept IDs
        // (imagesInServerUrlArr and existingImageIds come from FetchDetails)

        const imageIdsToUpdate = existingImages.filter((img) => currentImageUrls.includes(img.fileUrl))
              .map((img) => img.id);

        //const editorData = geofenceDescription;
        //const editorImages = editorData.match(/<img\s+[^>]*src=["'][^"']+["']/gi) || [];
        const editorImages = cleanedDescription.match(/<img\s+[^>]*src=["'][^"']+["']/gi) || [];
        const totalImages = editorImages.length;

        const totalFileSizeOfEditor = calculateTotalFileSizeAttachedInEditor(currentImageUrls);
        console.log('Total file size after update', totalFileSizeOfEditor /(1024 * 1024));
        
        if (totalFileSizeOfEditor > FIFTY_MB_FILE_SIZE_VALUE) {
          messageApi.error("Total image size cannot exceed 50MB.");
          setPublishModal({ open: false });
          return -999;
        }

        if (totalImages > 20) {
            messageApi.error('Maximum 20 images are allowed.');
            setPublishModal({ open: false });
            return -999;
        }

        try {
          setPublishModal({ open: false });

          let successMessage : string = '';
          if(statusId === NotificationStatusMapper.getNotificationStatusId('Draft') ){
            setIsDraftSaving(true);
            successMessage= "Notification updated successfully as Draft.";
          }

          if(statusId === NotificationStatusMapper.getNotificationStatusId('Active') ){
            setIsPublishing(true);
            successMessage = "Notification rescheduled successfully.";
          }

          const distanceUnit = form.getFieldValue("DistanceUnit");
          const radialDistance = form.getFieldValue("RadialDistance");
          const selected = form.getFieldValue("notifications") || [];

          const start = form.getFieldValue("startDateTime");
          const end = form.getFieldValue("endDateTime");
          const valuesAddressInfo = form.getFieldsValue([ "Latitude", "Longitude"]);
          
          // const isLatLongEmpty =
          //   !valuesAddressInfo.Latitude && !valuesAddressInfo.Longitude;

          //let markerPointStr: string = '';
            const putBodyGeofence: GeofenceNotificationUpdateParams = {
                  id: geofenceNotificationId,
                  campaignName: form.getFieldValue("CampaignName"),
                  status: statusId,
                  ...(start
                    ? {
                      startDate: dayjs(start).format("YYYY-MM-DD"),
                      startTime: dayjs(start).format("hh:mm A"),
                    }
                    : {}),

                  ...(end
                    ? {
                      endDate: dayjs(end).format("YYYY-MM-DD"),
                      endTime: dayjs(end).format("hh:mm A"),
                    }
                    : {}),
                    ...(valuesAddressInfo.Latitude && valuesAddressInfo.Longitude
                      ? {
                        centreCoordinate: [
                          String(valuesAddressInfo.Longitude),
                          String(valuesAddressInfo.Latitude),
                        ],
                      }
                      : centreCoordinate?.length > 0
                        ? { centreCoordinate }
                        : selectedFeature
                          ? (() => {
                            const markerPointObj = buildMarkerPoint(selectedFeature);
                            const coords = markerPointObj?.geometry?.coordinates;
                            return coords?.[0] != null && coords?.[1] != null
                              ? {
                                centreCoordinate: [
                                  coords[0].toString(),
                                  coords[1].toString(),
                                ],
                              }
                              : {};
                          })()
                          : {}),
                          
                ...(isNavigationAdded ? { isNavigation: isNavigationAdded } : {}),

                ...(inputValue ? { locationAddress: inputValue } : {}),

                ...(selected.includes("inapp") ? { inAppNotification: true } : {}),
                ...(selected.includes("push") ? { pushNotification: true } : {}),
                ...(selected.includes("email") ? { emailNotification: true } : {}),

                ...(form.getFieldValue("Subject")
                  ? { subjectLine: form.getFieldValue("Subject") }
                  : {}),

                ...(form.getFieldValue("EmailText")
                  ? { emailText: form.getFieldValue("EmailText") }
                  : {}),

                ...(distanceUnit === "km" && radialDistance
                  ? { km: radialDistance }
                  : {}),

                ...(distanceUnit === "miles" && radialDistance
                  ? { mile: radialDistance }
                  : {}),

                ...(form.getFieldValue("Title")
                  ? { title: form.getFieldValue("Title") }
                  : {}),

                ...(form.getFieldValue("Subtitle")
                  ? { subTitle: form.getFieldValue("Subtitle") }
                  : {}),

                ...(cleanedDescription ? { description: cleanedDescription } : {}),

                  timeZone: TimeZone.getFriendlyTimeZone(),
                  geofenceAnnouncementImagesIDs: imageIdsToUpdate,
                  };
            
            console.log(JSON.stringify(putBodyGeofence, null, 2));
            const resultPostGeoNotification = await geofenceNotificationApi.putGeofenceNotification(putBodyGeofence);
            
            const uploadedUrls = await uploadGeofenceNotificationImagesInServer(geofenceNotificationId);
            
            if(uploadedUrls && uploadedUrls.length > 0){
              patchDescriptionFromBase64ToImageUrl(uploadedUrls, geofenceNotificationId, cleanedDescription);
            }

            messageApi.success(successMessage);
        } catch (err) {
            const apiErrorMessage = err?.response?.data?.Message;
            messageApi.error(apiErrorMessage || 'Something went wrong');
            console.log("Failed to update geofence notification:", err);
            return -999;
        }
        finally{
            setIsDraftSaving(false);
            setIsPublishing(false);
        }
    };

    //Image upload in the server
    const uploadGeofenceNotificationImagesInServer = async (geofenceAnnouncementSupportID: string ) => {
      const uploadedGeofenceNotificationImageUrls: string[] = [];
        if (imageData && imageData.length > 0) {
          let count = 1;
            for (const img of imageData) {
               const params: GeofenceNotificationImageParams = {
                GeofenceAnnouncementSupportID: geofenceAnnouncementSupportID,
                GeofenceAnnouncementFile: img.file
              };

            const startTime = performance.now(); 
            console.log(`Starting upload image-${count}`, new Date().toISOString()); 

            const responsePostUpload = await geofenceNotificationApi.postGeofenceNotificationImageUpload(params);
            const endTime = performance.now(); 
             console.log(`End of API call ending upload image ${count}`, new Date().toISOString(), 
             "| Duration:", (endTime - startTime).toFixed(2), "ms");

            if (responsePostUpload?.fileUrl) {
                uploadedGeofenceNotificationImageUrls.push(responsePostUpload.fileUrl);
              }
               count++;
            }
          }
          return uploadedGeofenceNotificationImageUrls;
     };

     //Update description in the background
     const patchDescriptionFromBase64ToImageUrl = (uploadedGeofenceNotificationImageUrls: string[],
                geofenceAnnouncementSupportID: string, updatedDescription: string ) => {

        let geofenceDescriptionWithoutBase64 : string = '';
		    const base64ImgTags = updatedDescription.match(/<img[^>]+src=["']data:image\/[^"']+["'][^>]*>/g) || [];
            if(uploadedGeofenceNotificationImageUrls.length > 0 && base64ImgTags.length > 0){

                let index = 0;
                const base64ImgRegex = /<img[^>]+src=["']data:image\/(?:png|jpeg|jpg|gif|webp);base64,[\s\S]+?["'][^>]*>/g;

                geofenceDescriptionWithoutBase64 = updatedDescription.replace(base64ImgRegex, (match) => {
                  const fileUrl = uploadedGeofenceNotificationImageUrls[index++];
                  if (fileUrl) {
                    return `<img src="${fileUrl}" alt="uploaded-image-${index}" style="width: 120px;" />`;
                  }
                  return match;
                });

              const descriptionPatchBody : GeofenceNotificationDescriptionPatchBody = {
                id: geofenceAnnouncementSupportID,
                description : geofenceDescriptionWithoutBase64,
              };

              const startTime = performance.now(); 
            console.log("Starting patch description call at", new Date().toISOString());
              geofenceNotificationApi.patchGeofenceNotificationDescription(descriptionPatchBody);
              const endTime = performance.now(); 
             console.log("API call ended patch geofence desc", new Date().toISOString(), 
             "| Duration:", (endTime - startTime).toFixed(2), "ms");

            //console.log("PUT BODY", JSON.stringify(descriptionPatchBody, null, 2));
            }
     };

  const pageTitle =
        mode === "create" ? "Add Notification"
            : mode === "update"
                ? "Edit Notification"
                : "View Notification";
  const isDisabled = mode === "view";

  return (
    <>
    <div>
        {contextHolder}
        {
        isPageLoading && (
          <PageLoader />
        )}

        <Modal
          open={publishModal.open}
          onCancel={() => setPublishModal({ open: false })}
          footer={null}
          centered
          closable={false}
          bodyStyle={{
            textAlign: "center",
            padding: "24px 16px",
            borderRadius: 12,
          }}
        >
          <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
            Confirm Publish
          </h3>
          <p style={{ fontSize: 14, color: "#555", marginBottom: 24 }}>
            Are you sure you want to publish this notification?
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Button
              type="primary"
              block
              style={{
                backgroundColor: "#41787C",
                borderColor: "#41787C",
                height: 40,
                fontWeight: 500,
              }}
              onClick={() => {
                handlePublish();
              }}
            >
              Yes
            </Button>
            <Button
              block
              style={{
                backgroundColor: "#f2f2f2",
                border: "none",
                color: "#333",
                height: 40,
                fontWeight: 500,
              }}
              onClick={() => setPublishModal({ open: false })}
            >
              No
            </Button>
          </div>
        </Modal>

            {/* Header */}
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                    <Typography.Title level={3} style={{ margin: 0, color: "#41787C" }}>
                        <Button
                            type="link"
                            icon={<ArrowLeftOutlined />}
                            onClick={() => navigate(-1)}
                            style={{ marginBottom: 10, padding: 0 }}
                        />
                        {pageTitle}
                    </Typography.Title>
                </Col>
                {mode === "view" && (redirectedFrom.toLowerCase() === "draft" || redirectedFrom.toLowerCase() === "upcoming") && (
                    <Col>
                        <Button
                            type="default"
                            icon={<EditOutlined />}
                            onClick={() => handleEdit()}
                            style={{
                              backgroundColor: "#3E767A",
                              borderColor: "#3E767A",
                              color: "#fff",
                            }}
                        >Edit
                        </Button>
                    </Col>
                )}
            </Row>

            {/* Form */}
            <Form 
              form={form} layout="vertical"
              //onFinish={() => setPublishModal({ open: true })}
              onFinish={(values) => {
                if (formAction === 'draft') {
                  handleSaveAsDraft();
                } else if (formAction === 'publish') {
                  setPublishModal({ open: true });
                }
              }}  
              onFinishFailed={() => {
                setPublishModal({ open: false });
                let validationAlertMessage : string = '';
                if (formAction === 'draft') {
                  validationAlertMessage = 'Please fill in all mandatory fields before saving as draft.';
                } else if (formAction === 'publish') {
                  validationAlertMessage = 'Please fill in all mandatory fields before publishing.';
                }
                messageApi.error(validationAlertMessage);
              }}
              disabled={mode === "view"}
              requiredMark={false}
             >
              <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12}>
                      <Form.Item
                          name="CampaignName"
                          label={<span style={styles.campaignLabel}>Campaign Name<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                          rules={[{ required: true, message: "Please enter Campaign name" }]}
                      >
                          <Input placeholder="Enter Campaign name" style={styles.input} maxLength={100}/>
                      </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    label={<span style={styles.campaignLabel}>Campaign Duration<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                    style={{ marginBottom: 0 }}
                  >
                    <div style={{ display: "flex", gap: "8px" }}>
                      {/* Start Date & Time */}
                      <Form.Item
                        name="startDateTime"
                        noStyle
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const notifications = getFieldValue("notifications") || [];
                              if (notifications.length === 0 && !value) {
                                return Promise.reject("Start Date & Time is required");
                              }

                              if ((notifications.includes("inapp") ||
                                    notifications.includes("push") ||
                                    notifications.includes("email")) &&
                                  !value
                                ) {
                                  return Promise.reject("Start Date & Time is required");
                                }
                              
                              if (value) {
                                const nowPlus15 = moment().add(15, "minutes");
                                if (!value.isAfter(nowPlus15)) { 
                                  return Promise.reject("Start Date & Time must be at least 15 minutes in the future");
                                }
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          showTime={{ format: "hh:mm A" }}
                          format="MM/DD/YYYY hh:mm A" 
                          placeholder="Start Date & Time"
                          style={{ width: "50%", height: 43 }}
                           disabledDate={(current) => {
                            return current && current < dayjs().startOf('day');
                          }}
                          disabledTime={(current) => {
                                if (!current) return {};
                                const now = dayjs();
                                 const nowPlus15 = now.add(16, "minute");

                                if (current.isSame(now, 'day')) {
                                  const disabledHours = Array.from({ length: 24 }, (_, i) => i).filter(
                                    (h) => h < nowPlus15.hour()
                                  );

                                  const disabledMinutes = (selectedHour) => {
                                    if (selectedHour === nowPlus15.hour()) {
                                      return Array.from({ length: 60 }, (_, i) => i).filter(
                                        (m) => m < nowPlus15.minute()
                                      );
                                    }
                                    return [];
                                  };
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes,
                                  };
                                }
                                return {};
                              }}
                        />
                      </Form.Item>

                      {/* End Date & Time */}
                      <Form.Item
                        name="endDateTime"
                        noStyle
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const notifications: string[] = getFieldValue("notifications") || [];
                              const start: Moment = getFieldValue("startDateTime");
                              if (notifications.includes("inapp") && !value) {
                                return Promise.reject("End Date & Time is required for In-App Notification");
                              }
                              if (start && value && value.diff(start, 'seconds') < 1) {
                                return Promise.reject("End Date & Time must be after Start Date & Time");
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          showTime={{ format: "hh:mm A" }}
                          format="MM/DD/YYYY hh:mm A"
                          placeholder="End Date & Time"
                          style={{ width: "50%", height: 43 }}
                          disabledDate={(current) => {
                            return current && current < dayjs().startOf('day');
                          }}
                          disabledTime={(current) => {
                                if (!current) return {};
                                const now = dayjs();
                                const nowPlus15 = now.add(16, "minute");

                                if (current.isSame(now, 'day')) {
                                  const disabledHours = Array.from({ length: 24 }, (_, i) => i).filter(
                                    (h) => h < nowPlus15.hour()
                                  );

                                  const disabledMinutes = (selectedHour) => {
                                    if (selectedHour === nowPlus15.hour()) {
                                      return Array.from({ length: 60 }, (_, i) => i).filter(
                                        (m) => m < nowPlus15.minute()
                                      );
                                    }
                                    return [];
                                  };
                                  return {
                                    disabledHours: () => disabledHours,
                                    disabledMinutes,
                                  };
                                }
                                return {};
                          }}
                        />
                      </Form.Item>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 0 }}>
                  <Col xs={18}
                      sm={20}
                      md={20}>
                    <Form.Item
                      name="notifications"
                      label={<span>Notification Type<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                      rules={[{ required: true, message: "Please select at least one notification type" }]}
                      style={{ marginBottom: 0 }}
                    >
                      <Checkbox.Group className={stylesCheckbox.checkboxGroup}>
                        <Checkbox value="inapp">In-App Notification</Checkbox>
                        <Checkbox value="push">Push Notification</Checkbox>
                        <Checkbox value="email">Email Notification</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={6} 
                      sm={4}
                      md={4} 
                      style={{ textAlign: "right" }}>
                         <button style={{ ...styles.greenButton, marginTop: 0, whiteSpace: "nowrap", }}
                            type="button"
                            onClick={
                              isNavigationAdded
                                ? handleRemoveNavigation
                                : handleAddNavigation
                            }
                            disabled={mode === "view"}
                            >{isNavigationAdded ? "Remove Navigation" : "Add Navigation"}
                          </button>                      
                        {/* {isNavigationAdded ? ( 
                            <button style={{ ...styles.greenButton, marginTop: 0, whiteSpace: "nowrap", }}
                            type="button"
                            onClick={handleRemoveNavigation}
                            >Remove Navigation</button>
                         ) :
                         (
                            <button style={{ ...styles.greenButton, marginTop: 24 }}
                            type="button"
                            onClick={handleAddNavigation}
                            >Add Navigation</button>
                         )
                        } */}
                  </Col>
              </Row>
               <Row gutter={[16, 16]} style={{ marginBottom: 25 }}>
                  <Col xs={24} sm={24} md={12}>
                    <div style={styles.containerInnerControl}>
                     <Form.Item
                        name="Title"
                        label={<span style={styles.titleInnerControl}>Title<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                        labelCol={{ span: 24 }}
                        colon={false}
                        style={{ marginBottom: 0 }}
                        labelAlign="left"
                        rules={[{ required: true, message: "Please enter Title" }]}
                    >
                    {/* <div style={styles.titleInnerControl}>Title</div> */}
                    <Input placeholder="Enter Title" 
                        style={styles.inputInnerControl} maxLength={150} />
                    </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <div style={styles.containerInnerControl}>
                    <Form.Item
                        name="Subtitle"
                        label={<span style={styles.titleInnerControl}>Subtitle</span>}
                        labelCol={{ span: 24 }}
                        colon={false}
                        style={{ marginBottom: 0 }}
                        labelAlign="left"
                    >
                    <Input placeholder="Enter Subtitle" 
                        style={styles.inputInnerControl} maxLength={250} />
                     </Form.Item>
                    </div>
                  </Col>
                </Row>
                {isEmailSelected && (
                <Row gutter={[16, 16]} style={{ marginBottom: 25 }}>
                  <Col xs={24} sm={24} md={12}>
                    <div style={styles.containerInnerControl}>
                     <Form.Item
                        name="Subject"
                        label={<span style={styles.titleInnerControl}>Subject Line<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                        labelCol={{ span: 24 }}
                        colon={false}
                        style={{ marginBottom: 0 }}
                        labelAlign="left"
                        rules={[{ required: true, message: "Please enter Subject Line" }]}
                    >
                    {/* <div style={styles.titleInnerControl}>Title</div> */}
                    <Input.TextArea rows={6} placeholder="Enter Subject Line" 
                        style={styles.inputInnerControl} maxLength={150} />
                    </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <div style={styles.containerInnerControl}>
                    <Form.Item
                        name="EmailText"
                        label={<span style={styles.titleInnerControl}>Email Text<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                        labelCol={{ span: 24 }}
                        colon={false}
                        style={{ marginBottom: 0 }}
                        labelAlign="left"
                        rules={[{ required: true, message: "Please enter Email Text" }]}
                    >
                    <Input.TextArea rows={6} placeholder="Enter Email Text" 
                        style={styles.inputInnerControl} maxLength={1500} />
                     </Form.Item>
                    </div>
                  </Col>
                </Row>
                )}
            <Row gutter={[16, 16]} style={{ marginBottom: 25 }}>
              {/* Address */}
              <Col xs={24}>
                <div style={{ ...styles.containerInnerControl, height: "100%" }}>
                  <Form.Item
                    name="Address"
                    label={<span style={styles.titleInnerControl}>Address<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                    style={{ marginBottom: 16 }}
                    required
                    rules={[
                      {
                        validator: async (_, value) => {
                          const lat = form.getFieldValue("Latitude");
                          const lng = form.getFieldValue("Longitude");

                          // Case 1: Both empty
                          if ((!value || value.trim() === "") && (!lat || !lng)) {
                            return Promise.reject("Please enter either Address or Latitude & Longitude.");
                          }

                          // Case 2: Both provided
                          if (value && lat && lng) {
                            return Promise.reject("Please provide only one: either Address or Latitude & Longitude.");
                          }
                          
                          // Case 3: Address entered but "No search found"
                          if (value && !isAddressSelected) {
                            return Promise.reject("Please select a valid address from the list.");
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <div style={styles.autoCompleteWrapper}>
                    <AutoComplete
                      value={inputValue}
                      onSearch={(val) => debounceSearchRef.current?.(val)}
                      onChange={(val) => {
                          setInputValue(val);
                          // Only set isAddressSelected if value matches an option from API
                          const found = options.some(opt => opt.value === val);
                          setIsAddressSelected(found);
                          form.validateFields(["Address"]);
                      }}
                      onSelect={(value, option) => {
                        // option should contain the feature
                        handleSelect(value, option);
                        setIsAddressSelected(true);
                        form.validateFields(["Address"]);
                      }}
                      options={options}
                      filterOption={false}
                      dropdownMatchSelectWidth
                      style={{ width: "100%" }}
                    >
                      <Input
                        placeholder="Enter Address"
                        autoComplete="off"
                        style={{
                          width: "100%",
                          height: 40,
                          padding: "6px 12px",
                          fontSize: 14,
                          borderRadius: 6,
                          border: "1px solid #ccc",
                          boxSizing: "border-box",
                          color: isDisabled ? "#999" : (hasResults ? "#000" : "#999"),
                        }}
                      />
                    </AutoComplete>
                    </div>
                  </Form.Item>

                  {/* OR Divider */}
                  <div style={styles.orDivider}>
                    <div style={styles.orLine}></div>
                    <span style={styles.orText}>OR</span>
                    <div style={styles.orLine}></div>
                  </div>

                  <Form.Item
                      label={<span style={styles.titleInnerControl}>Latitude & Longitude<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                      labelCol={{ span: 24 }}
                      colon={false}
                      style={{ marginBottom: 8 }}
                      labelAlign="left"
                      required
                >
             <div style={{ display: "flex", gap: "16px", width: "100%" }}>
                  {/* Latitude */}
                <Form.Item
                  name="Latitude"
                   style={{ flex: 1, marginBottom: 0 }}
                   validateTrigger="onBlur"
                  rules={[
                     {
                        validator: async (_, value) => {
                          const address = form.getFieldValue("Address");
                          const lng = form.getFieldValue("Longitude");

                          // Case 1: Both empty
                          if (!address && (!value || !lng)) {
                            return Promise.reject("Please enter either Address or Latitude & Longitude.");
                          }

                          // Case 2: Both provided
                          if (address && (value || lng)) {
                            return Promise.reject("Please provide only one: either Address or Latitude & Longitude.");
                          }

                          // Regex check for number format
                        if (value !== undefined && value !== "") {
                          if (!/^-?\d+(\.\d+)?$/.test(value)) {
                            return Promise.reject("Latitude must be a valid number");
                          }
                          const num = parseFloat(value);
                          if (num < -90 || num > 90) {
                            return Promise.reject("Latitude must be between -90 and 90");
                          }
                        }
                          return Promise.resolve();
                        },
                      },
                  ]}
                >
                  <Input placeholder="Enter Latitude" style={{...styles.inputInnerControl, width: "100%"}} />
                </Form.Item>
                {/* Longitude */}
                <Form.Item
                  name="Longitude"
                   style={{ flex: 1, marginBottom: 0 }}
                   validateTrigger="onBlur"
                  rules={[
                    {
                      validator: async (_, value) => {
                        const address = form.getFieldValue("Address");
                        const lat = form.getFieldValue("Latitude");

                        // Case 1: Both empty
                        if (!address && (!value || !lat)) {
                          return Promise.reject("Please enter either Address or Latitude & Longitude.");
                        }

                        // Case 2: Both provided
                        if (address && (value || lat)) {
                          return Promise.reject("Please provide only one: either Address or Latitude & Longitude.");
                        }

                        // Case 3: Longitude numeric validation (optional)
                        // if (value && !/^-?\d+(\.\d+)?$/.test(value)) {
                        //   return Promise.reject("Longitude must be a valid number");
                        // }
                        // Regex check for number format
                        if (value) {
                          if (!/^-?\d+(\.\d+)?$/.test(value)) {
                            return Promise.reject("Longitude must be a valid number");
                          }
                          const num = parseFloat(value);
                          if (num < -180 || num > 180) {
                            return Promise.reject("Longitude must be between -180 and 180");
                          }
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input placeholder="Enter Longitude" style={{...styles.inputInnerControl, width: "100%",}} />
                </Form.Item>
              </div>
            </Form.Item>

                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{ marginBottom: 25 }}>
                  <Col xs={24} sm={24} md={24}>
                  <div style={styles.containerInnerControl}>  
                          {/* Layout row: title + radio */}
                          <div style={styles.headerRow}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div style={styles.titleInnerControl}>Radial Distance<span style={{ color: "red", marginLeft: 4 }}>*</span></div>
                            </div>
                            <Form.Item name="DistanceUnit" initialValue="km">
                            <Radio.Group defaultValue="km" className={stylesCheckbox.radioGroup}>
                              <Radio value="km" style={styles.radioRadial}>KM</Radio>
                              <Radio value="miles" style={styles.radioRadial}>Miles</Radio>
                            </Radio.Group>
                            </Form.Item>
                          </div>

                          {/* Only this Form.Item is used for validation */}
                          <Form.Item
                            name="RadialDistance"
                            style={{ marginBottom: 0 }}
                            rules={[
                              { required: true, message: "Please enter Radial Distance" },
                              {
                                pattern: /^[1-9]\d*$/,
                                message: "Radial Distance must be a positive integer",
                              },
                            ]}
                          >
                            <Input placeholder="Enter Radial Distance" style={styles.inputInnerControl} />
                          </Form.Item>
                        </div>
                  </Col>
            </Row>
                 <Row gutter={[16, 16]} style={{ marginBottom: 25 }}>
                  <Col xs={24}>
                    <div style={styles.containerInnerControlDescription }>
                     <Form.Item
                        name="Description"
                        label={<span style={styles.titleInnerControl}>Description<span style={{ color: "red", marginLeft: 4 }}>*</span></span>}
                        //labelCol={{ span: 24 }}
                        required
                        colon={false}
                        style={{ marginBottom: 0 }}
                        labelAlign="left"
                        rules={[
                        {
                          validator: (_, value) => {
                            const html = geofenceDescription || "";

                            // Extract plain text (remove all tags)
                            const textOnly = html.replace(/<[^>]+>/g, "").trim();

                            // Count <img> tags
                            const imageMatches = html.match(/<img\s+[^>]*>/gi) || [];
                            const imageCount = imageMatches.length;

                            if (textOnly === "" && imageCount === 0) {
                              return Promise.reject("Please enter notification description");
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                              <CKEditor
                                  editor={ClassicEditor as any}
                                  data={geofenceDescription}
                                  //disabled={mode === "view"}
                                  config={{
                                    placeholder: "Enter notification description",
                                    toolbar: [
                                        "heading", "|",
                                        "bold", "italic",  "underline", "link", "bulletedList", "numberedList", "|",
                                        "blockQuote", "undo", "redo", "imageUpload",
                                        "imageStyle:alignLeft", "imageStyle:alignCenter", "imageStyle:alignRight", "imageStyle:full",
                                        "alignment",
                                    ],
                                    image: {
                                        toolbar: [
                                            "imageStyle:alignLeft",
                                            "imageStyle:alignCenter",
                                            "imageStyle:alignRight",
                                            "imageStyle:full",
                                             "imageTextAlternative",
                                        ],
                                        resizeUnit: "%",
                                        resizeOptions: [
                                            { name: "resizeImage:original", label: "Original", value: null },
                                            { name: "resizeImage:25", label: "25%", value: "25" },
                                            { name: "resizeImage:50", label: "50%", value: "50" },
                                            { name: "resizeImage:75", label: "75%", value: "75" }
                                        ]
                                    },
                                }}
                                  onReady={handleReady}
                                  onChange={handleEditorChange}
                              />
                              {/* Editor styling */}
                              <style>
                            {`
                             ${mode === "view" ? `
                                .ck-toolbar { display: none !important; }
                              ` : ``}

                              .ck-editor__editable_inline {
                                min-height: 200px;
                                max-height: 200px;
                                overflow-y: auto;
                              }
                              .ck-content img {
                                width: 200px !important;
                                height: 200px !important;
                                object-fit: contain;
                                float: left;
                                margin: 0 auto !important;
                              }
                                /* Hide CKEditor watermark */
                              .ck-powered-by {
                                display: none !important;
                              }
                              .ck-powered-by-ckeditor {
                                display: none !important;
                              }
                              /* Alternative selectors for different CKEditor versions */
                              [class*="ck-powered-by"] {
                                display: none !important;
                              }
                              .ck-editor__main .ck-powered-by {
                                display: none !important;
                              }
                            `}
                            </style>
                    </Form.Item>
                    </div>
                  </Col>
                 </Row>
                <Row gutter={[16, 16]} justify="end" style={{ marginTop: 24 }} align="middle">
                   {/* Action Buttons */}
                 {/* <div style={styles.buttonRow}> */}
                  <Col xs={24} sm={12} md={6} lg="auto">
               
                
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="default" style={styles.greenButton} 
                    onClick={() => handleMobilePreview()}
                    disabled={false}
                    block
                    >
                        Mobile Preview
                    </Button>
                </Form.Item>
                </Col>
                 {mode !== "view" && (
                  <>
                   <Col xs={24} sm={12} md={6} lg="auto">
                  <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="default"
                      //htmlType="submit"
                      style={styles.whiteButton}
                      disabled={isDraftSaving}
                      //onClick={() => setFormAction('draft')}
                      onClick={async () => {
                        setFormAction('draft');
                        await handleSaveAsDraft();
                      }}
                      block
                    >
                      <span style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                        {isDraftSaving && <Spinner />}
                        {isDraftSaving ? 'Saving...' : 'Save as Draft'}
                      </span>
                    </Button>
                  </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={6} lg="auto">
                    <Form.Item style={{ marginBottom: 0 }}>
                      <Button type="primary"
                        htmlType="submit"
                        onClick={() => setFormAction('publish')}
                        style={styles.greenButton}
                        disabled={isPublishing}
                        block
                      >
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {isPublishing && <Spinner />}
                        {isPublishing ? 'Publishing...' : 'Publish'}
                        </span>
                      </Button>
                    </Form.Item>
                </Col>
                </>
                    )}
                    {/* </div> */}
                </Row>
                
            </Form>
            
            {/* Mobile Preview Drawer */}
                  {displayMobilePreview && (
                    <>
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          zIndex: 1000,
                        }}
                        onClick={() => setdisplayMobilePreview(false)}
                      />
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          right: 0,
                          width: "420px",
                          height: "100vh",
                          backgroundColor: "rgba(0, 0, 0, 0.4)",
                          boxShadow: "-2px 0 8px rgba(0,0,0,0.3)",
                          zIndex: 1001,
                          padding: "1rem",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "25px",
                        }}
                      >
                        <div
                          style={{
                            maxHeight: "calc(100vh - 140px)",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <GeofenceMobilePreviewPage 
                            form={form}
                             description={geofenceDescription}
                             imageData={imageData}
                             isNavigationVisible={isNavigationAdded}
                             mode={mode}
                             fileUrl={imagesInServerUrlArr}
                             />
                        </div>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <button
                          onClick={() => setdisplayMobilePreview(false)}
                          style={{ ...styles.CloseButton, width: 150, color: "black" }}
                        >
                          Close Preview
                        </button>
                        </div>
                      </div>
                    </>
                  )}
            
        </div>
        </>
  );
};

export default CreateGeofencePage;

const baseGreen = '#3E767A';

const styles: { [key: string]: React.CSSProperties } = {
  
  container: {
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    backgroundColor: '#f9f9f9',
    maxWidth: '600px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #d9d9d9',
    background: '#F9F9FA 0% 0% no-repeat padding-box',
    outline: 'none',
  },
  inputGroup: {
    flex: 1,
    marginRight: '10px',
  },
  campaignLabel: {
    color: '#3E767A',
    fontSize: '20px',
    marginBottom: '7px',
    fontWeight: 630,
    //textAlign: 'left',
    lineHeight: '24px',
  },
  button: {
    backgroundColor: '#ff4d4f',
    color: 'white',
    border: 'none',
    padding: '10px 15px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginBottom: '20px',
  },
  section: {
    marginBottom: '15px',
  },
  radialDistance: {
    marginTop: '20px',
  },
  distanceInput: {
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '100%',
    marginBottom: '10px',
  },
  distanceUnit: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
  },
  checkboxGroup: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    marginBottom: "25px",
  },
  // checkbox: {
  //   accentColor: baseGreen,
  //   cursor: "pointer",
  // },
  // checkboxlabel: {
  //   display: "flex",
  //   alignItems: "center",
  //   gap: "6px",
  //   cursor: "pointer",
  // },
  containerInnerControl: {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "20px",
    backgroundColor: "#f9f9f9",
    maxWidth: "100%",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
  containerInnerControlDescription : {
    border: "1px solid #eee",
    borderRadius: "12px",
    padding: "20px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
  titleInnerControl: {
    color: "#C19763",
    fontWeight: "bold",
    marginBottom: "8px",
    paddingBottom: "4px",
    borderBottom: "2px solid #C19763",
    display: "inline-block",
  },
  inputInnerControl: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    outline: "none",
    marginTop: "10px",
    fontSize: "14px",
  },
  radioGroup: {
    display: "flex",
    //gap: "10px",
    color:baseGreen,
  },
  radioRadial: {
    accentColor: baseGreen,
    cursor: "pointer",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    //marginBottom: "10px",
  },
  whiteButton :
	{
    padding: "8px 24px",
    minWidth: "140px",
    fontSize: '13px',
    borderRadius: '20px',
    fontWeight: 600,
    border: `2px solid #F1F2F4`,
    color: baseGreen,
    cursor: 'pointer',
    //transition: 'all 0.2s ease-in-out',
    backgroundColor: '#F1F2F4',
    //boxShadow: '0 2px 0 #F1F2F4',
    //transform: 'translateY(2px)',
  },
  greenButton :
	{
    padding: "8px 16px",
    fontSize: '13px',
    borderRadius: '20px',
    fontWeight: 600,
    border: `2px solid ${baseGreen}`,
    color: '#F1F2F4',
    cursor: 'pointer',
    //transition: 'all 0.2s ease-in-out',
    backgroundColor: baseGreen,
    //width: '170px',
    //height: '35px',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '30px',
  },
  addNavigationButton: {
  backgroundColor: "#4CAF50", // green
  color: "white",
  border: "none",
  padding: "8px 16px",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "14px",
 },
  orDivider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "25px 0",
    width: "100%",
  },

  orLine: {
    flex: 1,
    height: "1px",
    backgroundColor: "#C19763", // gold-ish line color
  },

  orText: {
    color: "#C19763",
    fontWeight: 600,
    margin: "0 10px",
    fontSize: "14px",
  },
  autoCompleteWrapper: {
  display: "block",
  position: "relative",
  paddingBottom: "22px", // gives space for validation text
  },
  okButton: {
    backgroundColor: "#3E767A",
    borderColor: "#3E767A",
    color: "#fff",
  },
  CloseButton : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: "8px 16px",
    fontSize: '13px',
    borderRadius: '20px',
    border: `2px solid ${baseGreen}`,
    color: '#F1F2F4',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: '#f1f2f4',
    fontWeight: 600,
    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  },
};
